function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolusion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.59 349.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M677.11,391.06c7.19-16.74,20-23.34,38-23.22,63.25.39,126.5.1,189.76.18,18.3,0,31.37,10.36,35.57,27.54,1.9,7.8,1.27,15.51-2.63,22.31-20,34.91-40.37,69.64-60.6,104.43.15-4,.53-8,.4-12-.55-17.16-14.84-32.3-31.86-32.41-44-.27-87.93.06-131.89.14a2.3,2.3,0,0,0-1.57-.77c-9.32-16.48-18.26-33.18-28.09-49.34-6.47-10.65-10.11-21.57-8.47-34l-.17.22Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#ffc302"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.31,477.27a2.3,2.3,0,0,1,1.57.77,41.66,41.66,0,0,0,2.2,5.43q13.38,23.41,26.88,46.76c11.5,19.89,22.72,39.94,34.64,59.57,10.74,17.68,27.63,22.45,46.56,14.16a36.35,36.35,0,0,1,7-1.81c-.84,2.73-4.06,8.06-4.06,8.06-17,29.7-34,59.43-51.4,88.93-11.38,19.33-35.35,24-52.37,10.35a41.4,41.4,0,0,1-9.45-11.42q-48.3-83.24-96.3-166.66c-8.42-14.57-7.45-28.49,2.56-41.89l1.56-1.67-.22.2c.72-.73,1.44-1.46,2.17-2.18l-.15.13c9.29-6.71,19.6-8.67,31-8.39C673.78,478.08,693.05,477.44,712.31,477.27Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#885af2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.18,602.15a34.39,34.39,0,0,0-7,1.81c-18.93,8.29-35.82,3.52-46.56-14.16-11.92-19.63-23.14-39.68-34.64-59.57q-13.49-23.36-26.88-46.76a41.66,41.66,0,0,1-2.2-5.43c44-.08,87.93-.41,131.89-.14,17,.11,31.31,15.25,31.86,32.41.13,4-.25,8-.4,12q-20.51,35.93-41,71.82",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#ff3f80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.31,477.27c-19.26.17-38.53.81-57.78.34-11.41-.28-21.72,1.68-31,8.39.62-2.13.84-4.49,1.92-6.36q23.77-41.46,47.79-82.79a20.52,20.52,0,0,1,2.52-2.94c-1.64,12.45,2,23.37,8.47,34C694.05,444.09,703,460.79,712.31,477.27Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#06d3e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.11,391.06l-1.53,3.07Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#06d3e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.67,485.87c-.73.72-1.45,1.45-2.17,2.18C622.22,487.32,622.94,486.59,623.67,485.87Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#06d3e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.72,487.85l-1.56,1.67Z",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#06d3e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.68,599.39",
    transform: "translate(-611.91 -367.83)",
    style: {
      fill: "#885af2"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolusion);
export default __webpack_public_path__ + "static/media/volusion.25391f64.svg";
export { ForwardRef as ReactComponent };